export const _document = 'document',
  _classList = 'classList',
  _add = 'add',
  _remove = 'remove',
  _toggle = 'toggle',
  _querySelectorAll = 'querySelectorAll',
  _querySelector = 'querySelector';
